import moment from 'moment'
import utils from '../../utils'

export const DEFAULT_START = 8 * 60
export const DEFAULT_END = 18 * 60
export const EXTRA_MINUTES = 60
export const FULL_DAY_MINUTES = 24 * 60
export const RESOURCE_COLORS = ['#d9f2ff', '#67d1ff', '#7ff9ff']
export const ITEM_HEIGHT = 48
export const ITEM_GAP = 8
export const ROW_PADDING_TOP = 6
export const toMinutes = time => {
  const [h = '0', m = '0'] = time.split(':')
  return Number(h) * 60 + Number(m)
}

export const floorHour = min => Math.floor(min / 60) * 60

export const ceilHour = min => Math.ceil(min / 60) * 60

export const formatTime = min => {
  const h = Math.floor(min / 60)
  const m = min % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

export const generateAxis = (start, end, step) => {
  const times = []
  for (let t = start; t <= end; t += step) {
    times.push(t)
  }
  return times
}

export const URL_REGEX_SPLIT = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi
export const URL_REGEX_TEST = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/i

export const linkifyText = text => {
  if (!text) return []

  const parts = text.split(URL_REGEX_SPLIT)

  return parts
    .filter(part => part !== '')
    .map(part => {
      if (URL_REGEX_TEST.test(part)) {
        const href = part.startsWith('http') ? part : `https://${part}`
        return { type: 'link', value: part, href }
      }
      return { type: 'text', value: part }
    })
}

// Hàm logic để phân tầng các sự kiện
export const stackEvents = events => {
  const sortedEvents = [...events].sort(
    (a, b) => toMinutes(a.startTime) - toMinutes(b.startTime)
  )
  const rows = []

  sortedEvents.forEach(event => {
    let placed = false
    const eventStart = toMinutes(event.startTime)

    for (let i = 0; i < rows.length; i++) {
      const lastEventInRow = rows[i][rows[i].length - 1]
      // Nếu sự kiện bắt đầu sau khi sự kiện cuối cùng của tầng này kết thúc
      if (eventStart >= toMinutes(lastEventInRow.endTime)) {
        rows[i].push(event)
        placed = true
        break
      }
    }
    if (!placed) rows.push([event])
  })
  return rows
}

export const convertToOfficeCalendarResources = (response = []) => {
  const map = new Map()

  response.forEach((item, index) => {
    const location = (item.location || 'Unknown').trim()

    const start = moment(item.start_at)

    const end = item.end_at
      ? moment(item.end_at)
      : start
          .clone()
          .hour(start.hour() <= 18 ? 18 : 23)
          .minute(0)
          .second(0)

    const event = {
      id: item.schedule_code || index,
      title: utils.removeHtml(item?.event_notice) || 'Không có nội dung',
      date: start.format('DD/MM/YYYY'),
      startTime: start.format('HH:mm'),
      endTime: end.format('HH:mm'),
      host: item.host || '',
      location,
      preparation: item?.preparation || '',
    }

    if (!map.has(location)) {
      map.set(location, {
        id: map.size + 1,
        name: location,
        events: [],
      })
    }

    map.get(location).events.push(event)
  })

  const result = Array.from(map.values()).map(resource => ({
    ...resource,
    events: resource.events.sort((a, b) =>
      a.startTime.localeCompare(b.startTime)
    ),
  }))

  return result
}

export const mockOfficeCalendarResources = [
  {
    id: 1,
    name: 'Phòng họp AC20',
    events: [
      {
        id: 1011,
        title: 'Họp đầu ca',
        date: '2025-06-13',
        startTime: '08:20',
        endTime: '08:35',
        host: 'Mr Thắng',
        location: 'Phòng họp AC20',
      },
      {
        id: 101,
        title: 'Họp giao ban (Sáng)',
        date: '2025-06-13',
        startTime: '08:30',
        endTime: '10:00',
        host: 'Mr Thắng',
        location: 'Phòng họp AC20',
      },
      {
        id: 102,
        title: 'Họp khẩn chiến lược (Trùng 1 phần)',
        date: '2025-06-13',
        startTime: '09:15', // Bắt đầu khi 101 chưa kết thúc -> Phải xuống tầng 2
        endTime: '11:00',
        host: 'Ms Trang',
        location: 'Phòng họp AC20',
      },
      {
        id: 103,
        title: 'Phỏng vấn ứng viên (Trùng tầng 2)',
        date: '2025-06-13',
        startTime: '10:15', // Bắt đầu khi 102 đang diễn ra -> Phải xuống tầng 3 (vì tầng 1 lúc này đã trống nhưng thuật toán waterfall thường ưu tiên tầng mới hoặc check kỹ slot)
        endTime: '11:45',
        host: 'HR Team',
        location: 'Phòng họp AC20',
      },
      {
        id: 104,
        title: 'Họp Review (Tầng 1 trống lại)',
        date: '2025-06-13',
        startTime: '13:45', // Lúc này 12:00-13:30 là giờ nghỉ, tầng 1 đã trống từ lâu -> Nên quay lại tầng 1
        endTime: '15:00',
        host: 'Mr Khoa',
        location: 'Phòng họp AC20',
      },
    ],
  },
  {
    id: 2,
    name: 'Phòng họp AC21',
    events: [
      {
        id: 201,
        title: 'Training React (Ca 1)',
        date: '2025-06-13',
        startTime: '14:00',
        endTime: '16:00',
        host: 'Technical Leader',
        location: 'Phòng họp AC21',
      },
      {
        id: 202,
        title: 'Training UI/UX (Trùng hoàn toàn)',
        date: '2025-06-13',
        startTime: '14:30', // Nằm lọt thỏm trong thời gian 201
        endTime: '15:30',
        host: 'Design Team',
        location: 'Phòng họp AC21',
      },
      {
        id: 203,
        title: 'Workshop Soft Skills',
        date: '2025-06-13',
        startTime: '15:00', // Trùng cả 201 và 202 -> Phải xuống tầng 3
        endTime: '17:00',
        host: 'HR',
        location: 'Phòng họp AC21',
      },
    ],
  },
  {
    id: 3,
    name: 'Phòng họp AC22',
    events: [
      {
        id: 301,
        title: 'Họp đối tác Nhật Bản',
        date: '2025-06-13',
        startTime: '08:00',
        endTime: '12:00', // Kéo dài đến tận giờ nghỉ
        host: 'Giám đốc',
        location: 'Phòng họp AC22',
      },
      {
        id: 302,
        title: 'Hợp đồng thầu (Trùng ít)',
        date: '2025-06-13',
        startTime: '11:50', // Trùng 10 phút cuối của 301
        endTime: '13:00',
        host: 'Ms Nhi',
        location: 'Phòng họp AC22',
      },
    ],
  },
]
